import React from 'react';
import { useSspState } from '../../../../components/hooks/common';
import ImageWithWebp from '../../Common/ImageWithWebp';
import { generatePageDimension } from '../../../../mappers/polotno';
import { SceneLayerSettings } from '../../../../interfaces';
import useLayerAnimation from './hooks/animation';

export const SBLayerAnimatedImage = ({
  setting,
  onError,
  portrait,
  layerType,
  canPlay = true
}: {
  setting: SceneLayerSettings;
  onError: (event: any) => void;
  portrait: boolean;
  layerType: string;
  canPlay?: boolean;
}) => {
  const isSsp = useSspState();
  const loadingMethod = !isSsp ? 'lazy' : 'eager';

  const { url, width, height, x, y, rotation } = setting;
  const [pageWidth, pageHeight] = React.useMemo(
    () => generatePageDimension(portrait && layerType === 'mobile'),
    [url, portrait, layerType]
  );

  const relativeX = (x / pageWidth) * 100;
  const relativeY = (y / pageHeight) * 100;
  const relativeWidth = (width / pageWidth) * 100;
  const relativeHeight = (height / pageHeight) * 100;

  const animatedLayer = useLayerAnimation(setting, canPlay, [pageWidth, pageHeight]);
  return (
    <div className="image-layer" ref={animatedLayer}>
      <ImageWithWebp
        src={url}
        style={{ objectPosition: portrait ? 'center top' : 'center center' }}
        onError={onError}
        loading={loadingMethod}
        className='webp-image-layer'
      />
      <style jsx>{`
            .image-layer {
                position: absolute;
                pointer-events: none;
                left: ${relativeX}%;
                top: ${relativeY}%;
                width: ${relativeWidth}%;
                height: ${relativeHeight}%;
                transform: rotate(${rotation}deg);
                transform-origin: center center;
          }
           :global(.webp-image-layer){
            width: 100%;
            height: 100%;
            object-fit: contain;
            vertical-align: top;
          }
          @media (orientation: portrait) {
            :global(.webp-image-layer){
              object-position: center;
            }
          }
        `}</style>
    </div>
  );
};

export default SBLayerAnimatedImage;

